import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FiltroConsultaEAD } from "./model";
import { CamionEAD } from "app/features/selectores/index";
type Entity = Partial<FiltroConsultaEAD>;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Componente para editar un Entity
*/
export class FiltroConsultaEADComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);
    render() {
        const getField = this.getField;
        const Camion = getField(selectores.CamionEAD);
        return (
            <div>
                {kea.autogrid(3, [
                    <Camion field="idCamionEAD" label="Camión" />
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaEAD/filtro.tsx